import type {
  GroupByOption,
  ScheduleWorkerRow,
} from "web-apps/company/components/schedule/types/schedule.types";

export const getRowRenderKey = (
  workerRow: ScheduleWorkerRow,
  groupByOption: GroupByOption,
): string => {
  const sectionIds = workerRow.sections.map((section) => section.id).join("-");
  return `row-${groupByOption}-${workerRow.id}-${sectionIds}`;
};
